var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"in_btn",class:_vm.MyType+' '+_vm.MySize,style:(_vm.BtnStyle + (_vm.borderRadius?'border-radius:20px':'')),on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.nama))])
}
var staticRenderFns = []

export { render, staticRenderFns }